import { Alert, Snackbar } from "@mui/material";
import { useCallback, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppContext } from "../../hooks/useAppContext";
import { useI18n } from "../../hooks/useI18n";
import { useServiceBus } from "../../hooks/useServiceBus";
import { PageLayout } from "../../layout/PageLayout";
import { HealthRecordForm, HealthRecordFormHandler } from "./HealthRecordForm";
import { EvcImportPage } from "./EvcImportPage";

export function NewHealthRecord() {
  const { t } = useI18n();
  const serviceBus = useServiceBus();
  const { organizationId, teamId } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [errorDisplayed, setErrorDisplayed] = useState<boolean>(false);
  const evcToken = searchParams.get("evc");

  const onSubmit: HealthRecordFormHandler = useCallback(
    (body) => {
      (async () => {
        try {
          const result = await serviceBus.dispatch({
            type: "createHealthRecord",
            ...body,
            organizationId,
            teamId,
          });

          if (result.type == "success") {
            // TODO: Use service bus navigation
            const path = location.pathname.replace("/new", `/${result.value.id}`);
            navigate(path);
          } else {
            setErrorDisplayed(true);
          }
        } catch (_error) {
          setErrorDisplayed(true);
        }
      })();
    },
    [serviceBus, navigate, location, organizationId, teamId],
  );

  if (evcToken) {
    return <EvcImportPage />;
  }

  return (
    <PageLayout title={t("patients.add")}>
      <HealthRecordForm onSubmit={onSubmit} />
      <Snackbar
        open={errorDisplayed}
        autoHideDuration={6000}
        onClose={() => setErrorDisplayed(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error">{t("common.alerts.alert_classic")}</Alert>
      </Snackbar>
    </PageLayout>
  );
}
